<form class="login-form" [class.block-loader]="formLoader.isLoading">
	<loader-spinner [model]="formLoader"/>
</form>


